<template>
<!--
<div class="col-lg-9 col-xl-10 col-xs-12">
  <b-button variant="default" @click="goBack()">
    <i class="fa fa-angle-left fa-lg" />
  </b-button>
  -->
  <div>
  <Widget class="mt-lg-4">
    <div class="widgets-page">
    <div class="widget-top-overflow widget-padding-md clearfix bg-warning text-white">
      <h3 class="mt-lg mb-lg" v-html="passedTask.Title"></h3>
      <!--
      <ul class="tags text-white pull-right">
        <li><a href="#">features</a></li>
      </ul>
      -->
    </div>
    <div class="post-user mt-negative-lg">
      <span class="thumb-lg pull-left mr mt-n-sm">
        <img class="rounded-circle" src='../../../../assets/people/a4.jpg' alt="..." />
      </span>
      <h4 class="m-b-1 fw-normal text-white">
        <small class="text-white text-light">Posted By: {{taskCreator}}</small>
      </h4>
      <!--
      <p class="fs-mini text-muted">
        <time>25 mins</time>
        &nbsp; <i class="fa fa-map-marker" /> &nbsp; near Emerson, NJ
      </p>
      -->
    </div>
    <p class="text-light fs-mini mt-lg">
      {{passedTask.Notes}}
    </p>
    <footer class="bg-body-light">
      <ul class="post-links">
        <li><a href="#">Posted {{ passedTask.CreatedAt | dateformatwithtime(this.settings.Timezone)}}</a></li>
        <!--
        <li>
          <a href="#"><span class="text-danger">
            <i class="fa fa-heart" /> Like</span>
          </a></li>
        <li><a href="#">Comment</a></li>
        -->
      </ul>
      <TaskPages v-if="passedTask.HasPages" :Pages="passedTask.Pages" />
      <TaskAssets v-if="passedTask.HasAssets" :Assets="passedTask.Assets" />
      <TaskComments :Comments="passedTask.Comments" :Employees="employees" :TaskID="passedTask.id"/>
    </footer>
    </div>
  </Widget>
  </div>
</template>

<script>

/* eslint-disable */

import Widget from '@/components/Widget/Widget';
import TaskHeader from '../TaskHeader/TaskHeader';
import TaskPages from '../../../../components/TaskPages/TaskPages';
import TaskComments from '../../../../components/TaskComments/TaskComments';
import TaskAssets from '../../../../components/TaskAssets/TaskAssets';
import { mapState, mapActions } from 'vuex';
import moment from 'moment-timezone';
import 'moment-timezone';

export default {
  name: 'Task',
  components: { Widget, TaskHeader, TaskPages, TaskComments, TaskAssets },
  props: ['passedTask'],

  async created() {
      //await this.getSites( { customerID: this.customerID});
      //await this.getEmployees({ siteID: this.siteID });
      this.init();
  },

  methods: {
    ...mapActions('customer', ['getSites', 'getEmployees']),

    init() {
      if(this.isEmpty(this.settings))
        //console.log('getting settings from API');
        this.getSites({ customerID: this.customerID});
      if(this.isEmpty(this.employees))
        this.getEmployees({ siteID: this.siteID });
    },

    isEmpty(obj) {
      for(var key in obj) {
          if(obj.hasOwnProperty(key))
              return false;
      }
      return true;
    },
  },
  computed: {
    ...mapState({
        loading: state => state.alert.loading,
        loaded: state => state.alert.loaded,
        errored: state => state.alert.errored,
        alertMessage: state => state.alert.message,
        employees: state => state.customer.employees,
        customerID: state => state.customer.customerID,
        siteID: state => state.customer.siteID,
        settings: state => state.customer.settings,
        task: state => state.tasks.task,
    }),

    taskToDisplay() {
      if (this.passedTask)
        return this.passedTask;
      else
        return this.task;
    },

    /*
    taskCreator() {
      if(this.employees.length > 0)
        return this.employees.find(e => e.id === this.taskToDisplay.CreatedByEmpID).EmployeeName;
    }
    */
  },

  asyncComputed: {
    taskCreator: {
      async get() {
        //await this.getEmployees({ siteID: this.siteID });
        return this.employees.find(e => e.id === this.taskToDisplay.CreatedByEmpID).EmployeeName;
      },
      default: 'Loading...'
    }
  }
};
</script>

<style src="./Task.scss" lang="scss" scoped />
